module.exports = "https://s91588.cdn.ngenix.net/cs-frontend-v2/_next/static/images/Kubik-1aa74453a5bc90bb3369a72adf891087.png";